module.exports = __webpack_public_path__ + "img/b9a89fc7b5364d1fa0d5c04f93251529-1440.c8264e0f.png";